import { render, staticRenderFns } from "./oring.vue?vue&type=template&id=58fd735d&scoped=true&"
import script from "./oring.vue?vue&type=script&lang=js&"
export * from "./oring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd735d",
  null
  
)

export default component.exports